import React from "react";

function About() {
  return (
    <div className="about-page">
      <section className="about-card">
        <p className="eyebrow">About GitHunt</p>
        <h1>Modern GitHub profile discovery for developers.</h1>
        <p>
          GitHunt brings together a clean search experience, polished profile views, and a
          developer-friendly interface for browsing GitHub users.
        </p>
        <div className="about-highlights">
          <div>
            <strong>React</strong>
            <span>Fast and component-driven UI for a smooth experience.</span>
          </div>
          <div>
            <strong>GitHub API</strong>
            <span>Real public profiles and repository data from GitHub.</span>
          </div>
          <div>
            <strong>Responsive UI</strong>
            <span>Accessible layouts that work across desktop and mobile.</span>
          </div>
        </div>
      </section>
      <section className="about-card accent">
        <h2>Built with care</h2>
        <ul>
          <li>React Router for seamless navigation</li>
          <li>GitHub REST API for live profile data</li>
          <li>Accessible, responsive UI patterns</li>
          <li>Profile comparison and repository insights for deeper exploration</li>
          <li>Smart search flow with polished empty and loading experiences</li>
        </ul>
        <a
          className="primary-btn"
          href="https://lakshaydhoundiyalportfolio.netlify.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit portfolio
        </a>
      </section>
    </div>
  );
}

export default About;
